import { HeartEmoji } from './heart.styles'

export const Heart = () => {
  return <HeartEmoji>❤️</HeartEmoji>
}
